<template>
  <div>
    <div class="card__container">
      <div class="attachment__filter">
        <label class="filter__header ml-1 mb-2">Attachment Management</label>
        <div>
          <div class="d-lg-flex align-items-center">
            <div class="col-lg-4">
              <atom-input
                v-model="filter.idcId"
                :title="contractIdLabel"
                :placeholder="contractIdLabel"
                type="number"
                :maxLength="8"
                @onKeyupEnter="clickButtonSearch"
              ></atom-input>
            </div>
            <div class="col-lg-4 mt-1 mt-lg-0">
              <atom-input
                title="Attachment Title"
                placeholder="Attachment Title"
                v-model="filter.title"
                @onKeyupEnter="clickButtonSearch"
              ></atom-input>
            </div>
            <div class="col-lg-4 mt-1 mt-lg-0">
              <atom-input
                title="Attachment File"
                placeholder="Attachment File"
                v-model="filter.filename"
                @onKeyupEnter="clickButtonSearch"
              ></atom-input>
            </div>
          </div>

          <div class="d-lg-flex align-items-center mt-1">
            <div class="col-lg-6">
              <label>Upload by</label>
              <atom-multi-select
                v-model="filter.uploadedBy"
                class="w-100"
                placeholder="All User"
                label="name"
                :option="userList"
                :isAppendToBody="false"
                :isEnableProper="false"
              ></atom-multi-select>
            </div>
            <div class="col-lg-6 mt-1 mt-lg-0">
              <label>Updated by</label>
              <atom-multi-select
                v-model="filter.updatedBy"
                class="w-100"
                placeholder="All User"
                label="name"
                :option="userList"
                :isAppendToBody="false"
                :isEnableProper="false"
              ></atom-multi-select>
            </div>
          </div>

          <div class="d-lg-flex align-items-center mt-1">
            <div class="col-lg-4">
              <atom-input
                title="Description"
                placeholder="Description"
                v-model="filter.description"
                @onKeyupEnter="clickButtonSearch"
              ></atom-input>
            </div>
            <div class="col-lg-8 mt-1 mt-lg-0">
              <label>Tag</label>
              <atom-multi-select
                v-model="filter.tag"
                class="w-100"
                placeholder="All Tag"
                :option="tagList"
                :isAppendToBody="false"
                :isEnableProper="false"
              ></atom-multi-select>
            </div>
          </div>

          <div class="d-lg-flex align-items-end mt-1">
            <div class="col-lg-4">
              <atom-datepicker
                datepickerId="upload-date__start"
                title="Start Upload Date"
                v-model="filter.startDate"
                :maxDate="filter.endDate ? filter.endDate : dateNow"
                type="dateNtime"
                placeholder="Select Start Date"
                :isDisabled="!filter.isEnableDate"
              ></atom-datepicker>
            </div>
            <div class="col-lg-4">
              <atom-datepicker
                datepickerId="upload-date__end"
                title="End Upload Date"
                v-model="filter.endDate"
                :minDate="filter.startDate"
                :maxDate="filter.endDate"
                type="dateNtime"
                placeholder="Select End Date"
                :isDisabled="!filter.isEnableDate"
              ></atom-datepicker>
            </div>
            <div class="col-lg-4 d-flex">
              <div class="d-flex flex-column">
                <label>Filter Date?</label>
                <atom-switch
                  v-model="filter.isEnableDate"
                  class="filter__switch"
                ></atom-switch>
              </div>
              <div class="d-flex align-items-end">
                <atom-button
                  buttonId="button-search"
                  iconLeft="SearchIcon"
                  @click="clickButtonSearch"
                  class="search__button ml-2"
                ></atom-button>
                <div
                  class="d-flex reset-filter-button ml-1"
                  @click="clickButtonClearFilter"
                >
                  <span>Reset</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <hr />

      <div class="attachment__table table-wrapper">
        <b-table
          responsive
          sticky-header
          :items="attachmentList"
          :fields="attachmentFields"
          :hover="false"
          @row-clicked="selectRow"
          show-empty
        >
          <template #cell(idc)="data">
            <div class="d-flex flex-column">
              <label class="text__name">
                {{ data.value.name || "-" }}
              </label>
              <label class="text__id">{{ data.value.ntdcId || "-" }}</label>
            </div>
          </template>

          <template #cell(attachment)="data">
            <div class="d-flex flex-column">
              <label class="text__name">{{ data.value.title || "-" }}</label>
              <div class="d-flex align-items-center">
                <feather-icon icon="FileTextIcon" size="18" />
                <span class="text__file tag__space mb-0">
                  {{ data.value.file.originalFileName || data.value.file.name }}
                </span>
              </div>
            </div>
          </template>

          <template #cell(description)="data">
            <label class="text__description">{{ data.value || "-" }}</label>
          </template>

          <template #cell(tag)="data">
            <div class="d-flex flex-wrap">
              <b-badge
                v-for="(tag, index) in data.value"
                :key="index"
                variant="light-primary"
                class="tag__space"
              >
                {{ tag }}
              </b-badge>
            </div>
          </template>

          <template #cell(upload)="data">
            <div class="d-flex flex-column">
              <label class="text__by">{{ data.value.uploadBy || "-" }}</label>
              <label class="text__date">{{ data.value.uploadAt || "-" }}</label>
            </div>
          </template>

          <template #cell(update)="data">
            <div class="d-flex flex-column">
              <label class="text__by">{{ data.value.updateBy || "-" }}</label>
              <label class="text__date">{{ data.value.updateAt || "-" }}</label>
            </div>
          </template>

          <template #cell(action)="data">
            <atom-button
              buttonId="button-delete"
              iconLeft="Trash2Icon"
              buttonStyle="flat"
              buttonColor="secondary"
              @click="deleteAttachment(data.item.id, data.item.idc.idcId)"
            ></atom-button>
          </template>

          <template #empty>
            <div
              class="d-flex flex-column align-items-center justify-content-center my-4"
            >
              <feather-icon
                icon="CloudOffIcon"
                class="empty-data__icon"
              ></feather-icon>
              <label class="empty-data__text--title">No Data</label>
            </div>
          </template>
        </b-table>
        <molecule-pagination-with-per-page
          :page="filter.pageNumber"
          :total-count="filter.totalCount"
          :per-page="filter.perPage"
          @onUpdatePaginationOrPerPage="onUpdatePaginationOrPerPage"
        ></molecule-pagination-with-per-page>
      </div>
    </div>

    <molecule-modal-dialog
      modalId="modal-confirm-delete-attachment"
      textTitle="Do you want to delete?"
      :textSubtitle="`Please check Contract Detail before delete\nYou won’t be able to revert this!`"
      :buttonTextLeft="`${
        isShowDeleteAttachmentInput ? 'Delete' : 'Go to Contract Detail'
      }`"
      buttonTextRight="Cancel"
      :buttonColorLeft="`${isShowDeleteAttachmentInput ? 'danger' : 'primary'}`"
      :isDisableButtonLeft="isDisableButtonDeleteAttachment"
      :isTextCenter="true"
      :isSlotBody="true"
      @clickButtonLeft="onClickButtonAttachmentFromModal"
      @clickButtonRight="clearDataAndCloseModal"
      @clickIconClose="clearDataAndCloseModal"
    >
      <template #body>
        <div class="w-100 px-69px">
          <label
            v-if="hasDeleteNtdcAttachmentPermission"
            class="text__option"
            :class="{ text_underline: isShowDeleteAttachmentInput }"
            @click="isShowDeleteAttachmentInput = !isShowDeleteAttachmentInput"
            >Advance Option</label
          >
          <atom-input
            v-if="isShowDeleteAttachmentInput"
            v-model="confirmDeleteText"
            title="Please type delete to confirm"
            :isAsterisk="false"
            placeholder="delete"
            class="mt-1"
          ></atom-input>
        </div>
      </template>
    </molecule-modal-dialog>
  </div>
</template>

<script>
import { DateTime } from "luxon"
import { BTable, BPagination, BBadge } from "bootstrap-vue"
import AtomInput from "@/components/atoms/AtomInput.vue"
import AtomMultiSelect from "@/components/atoms/AtomMultiSelect.vue"
import AtomDatepicker from "@/components/atoms/AtomDatepicker.vue"
import AtomButton from "@/components/atoms/AtomButton.vue"
import AtomSwitch from "@/components/atoms/AtomSwitch.vue"
import MoleculeModalDialog from "@/components/molecules/MoleculeModalDialog.vue"
import MoleculePaginationWithPerPage from "@/components/molecules/MoleculePaginationWithPerPage.vue"
import mixins from "@/mixins"
import mixinsUser from "@/mixins/mixinsUser"
import { PermissionUser } from "@/constants/permission-user"

export default {
  name: "OrganismAttachmentManagement",
  components: {
    AtomInput,
    AtomMultiSelect,
    AtomDatepicker,
    AtomButton,
    AtomSwitch,
    BTable,
    BPagination,
    BBadge,
    MoleculeModalDialog,
    MoleculePaginationWithPerPage,
  },
  mixins: [mixins, mixinsUser],
  props: {
    userList: {
      type: Array,
      required: true,
    },
    tagList: {
      type: Array,
      required: true,
    },
    filter: {
      type: Object,
      required: true,
    },
    attachmentFields: {
      type: Array,
      required: true,
    },
    attachmentList: {
      type: Array,
      required: true,
    },
  },
  emits: [
    "onFetchingData",
    "onUpdateFilterData",
    "onSetDefaultFilterData",
    "deleteAttachment",
  ],
  data() {
    return {
      dateNow: DateTime.now().toISO(),

      modalId: null,
      isDeleteAttachment: false,
      currentAttachmentId: null,
      currentIdcId: null,

      confirmDeleteText: null,

      isShowDeleteAttachmentInput: false,
    }
  },
  computed: {
    hasDeleteNtdcAttachmentPermission() {
      return this.hasPermission(PermissionUser.WPM.NTDC_ATTACHMENT_DELETE)
    },
    isDisableButtonDeleteAttachment() {
      if (this.isShowDeleteAttachmentInput) {
        return this.confirmDeleteText?.toLowerCase() !== "delete"
      }

      return false
    },
  },
  methods: {
    clickButtonSearch() {
      this.$emit("onUpdateFilterData", this.filter)
    },
    clickButtonClearFilter() {
      this.$emit("onSetDefaultFilterData")
    },

    selectRow(row) {
      if (!this.isDeleteAttachment) {
        this.redirectToContractDetail(row.idc.ntdcId)
      }
    },

    onClickButtonAttachmentFromModal() {
      if (this.isShowDeleteAttachmentInput) {
        this.confirmDeleteAttachment()
      } else {
        this.goToContractDetail()
      }
    },

    deleteAttachment(id, idcId) {
      this.isDeleteAttachment = true
      this.currentAttachmentId = id
      this.currentIdcId = idcId

      this.openModal("modal-confirm-delete-attachment")
    },

    confirmDeleteAttachment() {
      this.$emit(
        "deleteAttachment",
        this.currentAttachmentId,
        this.currentIdcId
      )

      this.clearDataAndCloseModal()
    },

    goToContractDetail() {
      const ntdcId = this.currentIdcId.toString().padStart(8, "0")
      this.clearDataAndCloseModal()
      this.redirectToContractDetail(ntdcId)
    },

    clearDataAndCloseModal() {
      this.isDeleteAttachment = false
      this.currentAttachmentId = null
      this.currentIdcId = null
      this.isShowDeleteAttachmentInput = false
      this.confirmDeleteText = null
      this.closeModal()
    },

    redirectToContractDetail(ntdcId) {
      this.$router.push(`/internal/web-portal/idc/contract/${ntdcId}`)
    },

    // modal
    openModal(id) {
      this.modalId = id
      this.$bvModal.show(this.modalId)
    },

    closeModal() {
      this.$bvModal.hide(this.modalId)
      this.modalId = null
    },

    onUpdatePaginationOrPerPage(currentPerPage, currentPage) {
      const updatedFilter = {
        ...this.filterList,
        currentPage,
        perPage: currentPerPage,
      }
      this.$emit("onUpdateCurrentPageOrPerPage", updatedFilter)
    },
  },
}
</script>

<style lang="scss" scoped>
.table-wrapper ::v-deep.b-table-sticky-header {
  min-height: 600px;
  max-height: calc(100vh - 625px);
  &:has(.b-table-empty-row) {
    min-height: 350px;
  }
}

.card__container {
  background-color: #fff;
  border-radius: 6px;
  box-shadow: 0px 4px 24px rgba(0, 0, 0, 0.06);
}

.attachment__filter {
  padding: 32px 16px;
}

hr {
  margin-top: 1rem;
  margin-bottom: 1rem;
  border: 0;
  border-top: 1px solid #ebe9f1;
}

.attachment__table {
  padding: 40px 0;
}

.filter__header {
  color: #5e5873;
  font-weight: 500;
  font-size: 18px;
}

.filter__switch {
  padding-top: 10px;
  height: fit-content;
}

.search__button {
  margin-top: 23px;
  margin-right: 0;
  height: fit-content;
}

.reset-filter-button {
  color: #b9b9c3;
  margin-bottom: 8px;
  text-decoration: underline;
  &:hover {
    cursor: pointer;
    color: #7367f0;
  }
}

.text__file {
  cursor: pointer;
  color: #7367f0;
  font-weight: 600;
  font-size: 12px;
  background: #eeedfd;
  align-items: center;
  padding: 0.3rem 9px;
  border-radius: 4px;
  text-decoration-line: underline;

  &:hover {
    background: #dfddff;
    color: #584cdb;
  }
}

.text__file {
  text-decoration-line: underline;

  &:hover {
    background: #dfddff;
    color: #584cdb;
  }
}

.tag__space {
  margin-left: 5px;
  margin-bottom: 5px;
}

.text__name {
  color: #6e6b7b;
  font-weight: 600;
  font-size: 14px;
}

.text__id {
  color: #6e6b7b;
  font-weight: 500;
  font-size: 14px;
}

.text__description {
  color: #6e6b7b;
  font-weight: 400;
  font-size: 14px;
}

.text__by {
  color: #6e6b7b;
  font-weight: 400;
  font-size: 14px;
}

.text__date {
  color: #b9b9c3;
  font-weight: 400;
  font-size: 12px;
}

.pagination__padding {
  padding: 20px;
}

.text__pagination {
  color: #b9b9c3;
  font-weight: 400;
  font-size: 14px;
}

.px-69px {
  padding: 0 69px;
}

.text__option {
  color: #b9b9c3;
  font-size: 10px;
  font-weight: 400;
  cursor: pointer;
}

.text_underline {
  text-decoration-line: underline;
}
</style>
